module.exports = __webpack_public_path__ + "static/img/12years.271d336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/12years.jpg
// module id = 4vx9
// module chunks = 0